import React from "react";
import { Config } from "@measured/puck";
import {
  OrganizationHero,
  OrganizationAbout,
  OrganizationEventsList,
  OrganizationStats,
  OrganizationSocialLinks,
  OrganizationContact,
} from "./components/organization";
import {
  EventHero,
  EventDescription,
  EventTicketSelection,
  EventDetails,
} from "./components/event";
import {
  Spacer,
  Text,
  Button,
  Divider,
  SectionBlock,
  MediaBlock,
  FeatureGrid,
  CustomNavbar,
  TextBoxBlock,
  IconGrid,
} from "./components/base";
import {
  NavbarSection,
  FooterSection,
  EventsSection,
  AboutUsSection,
  NewsletterSection,
} from "./components/sections";
import { RootPropsProvider } from "./context";

// Organization Page Config - Restricted to 5 fixed sections
export const organizationConfig: Config = {
  root: {
    render: ({
      children,
      ...rootProps
    }: {
      children: React.ReactNode;
      [key: string]: any;
    }) => {
      return (
        <RootPropsProvider
          value={{
            organization: (rootProps as any).organization,
            events: (rootProps as any).events,
          }}
        >
          {children}
        </RootPropsProvider>
      );
    },
  },
  components: {
    // Fixed Sections - Only these 5 sections allowed (in order)
    NavbarSection,
    AboutUsSection,
    EventsSection,
    NewsletterSection,
    FooterSection,
    // Content Blocks - Can be added between sections for styling
    Text,
    Button,
    SectionBlock,
    MediaBlock,
    TextBoxBlock,
    Spacer,
    Divider,
    // Legacy components (kept for backward compatibility)
    OrganizationHero,
    OrganizationAbout,
    OrganizationEventsList,
    OrganizationStats,
    OrganizationSocialLinks,
    OrganizationContact,
    FeatureGrid,
    CustomNavbar,
    IconGrid,
  },
};

// Event Page Config
export const eventConfig: Config = {
  root: {
    render: ({
      children,
      ...rootProps
    }: {
      children: React.ReactNode;
      [key: string]: any;
    }) => {
      return (
        <RootPropsProvider
          value={{
            event: (rootProps as any).event,
            tickets: (rootProps as any).tickets,
          }}
        >
          {children}
        </RootPropsProvider>
      );
    },
  },
  components: {
    // Event Components
    EventHero,
    EventDescription,
    EventTicketSelection,
    EventDetails,
    // Base Components
    Spacer,
    Text,
    Button,
    Divider,
    SectionBlock,
    MediaBlock,
    FeatureGrid,
    CustomNavbar,
    TextBoxBlock,
    IconGrid,
  },
};
